import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  ObtenerMovimientos(vm, data) {
    data.append("aiclave", vm.aiclave);
    data.append("uslogin", MetodosGenerales.ObtenerUserName());
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Movimientos/ObtenerMovimientos`, data)
      .then((response) => response.data);
  },
  EliminarMovimiento(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Movimientos/EliminarMovimiento`, data)
      .then((response) => response.data);
  },
  EditarMovimiento(vm, data) {
    data.append("uslogin", MetodosGenerales.ObtenerUserName());
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Movimientos/EditarMovimiento`, data)
      .then((response) => response.data);
  },
  ValidaIVR(vm, data) {
    return vm.axios
      .post(`${domain.domainNameForApi}Movimientos/ValidaIVR`, data)
      .then((response) => response.data);
  },
  ValidaElimina(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Movimientos/ValidaElimina`, data)
      .then((response) => response.data);
  },
  MovimientoSinCI(vm, data) {
    return vm.axios
      .post(`${domain.domainNameForApi}Movimientos/MovimientoSinCI`, data)
      .then((response) => response.data);
  },

  async ObtenerCatalogoGenerico(vm, tipo, apartado) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.nrreporte);
    datosReporte.append("svindice", vm.svindice);
    datosReporte.append("aiclave", vm.aiclave);
    datosReporte.append("tipo", tipo);
    datosReporte.append("apartado", apartado);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoGenerico`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerInfoAveriguacionPrevia(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.reporteInfo.nrreporte);
    formData.append("svindice", vm.reporteInfo.svindice);
    formData.append("aiclave", vm.reporteInfo.aiclave);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}Movimientos/AvePrevObtenerInfoInicialMovimientos`,
      formData
    );

    return response.data;
  },

  async MovimientosGeneralObtenerInfoInicial(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.reporteInfo.nrreporte);
    formData.append("svindice", vm.reporteInfo.svindice);
    formData.append("aiclave", vm.reporteInfo.aiclave);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}Movimientos/MovimientosGeneralObtenerInfoInicial`,
      formData
    );

    return response.data;
  },

  async MovimientosReporteComprobarPrestacion(datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("aiclave", datos.aiclave);

    let response = await axios.post(
      `${domain.domainNameForApi}Movimientos/ReporteComprobarPrestacion`,
      formData
    );

    return response.data;
  },

  async MovimientosGeneralObtenerInfoPrestacionEspecial(datos, astipo) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("aiclave", datos.aiclave);
    formData.append("astipo", astipo);

    let response = await axios.post(
      `${domain.domainNameForApi}Movimientos/MovimientosGeneralObtenerInfoPrestacionEspecial`,
      formData
    );

    return response.data;
  },

  async ObtenerCatalogoExtraInfo(vm, tipo, apartado) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", vm.reporteInfo.nrreporte);
    datosReporte.append("svindice", vm.reporteInfo.svindice);
    datosReporte.append("aiclave", vm.reporteInfo.aiclave);
    datosReporte.append("tipo", tipo);
    datosReporte.append("apartado", apartado);

    let response = await axios.post(
      `${domain.domainNameForApi}ExpJur/CatalogoExtraInfo`,
      datosReporte
    );

    return response.data;
  },

  async ObtenerInfoRobo(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.reporteInfo.nrreporte);
    formData.append("svindice", vm.reporteInfo.svindice);
    formData.append("aiclave", vm.reporteInfo.aiclave);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}Movimientos/AvePrevObtenerInfoRobo`,
      formData
    );

    return response.data;
  },

  async ValidarEFirma(vm, efirma) {
    var formData = new FormData();
    formData.append("efirma", efirma);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}Movimientos/ValidarEFirma`,
      formData
    );

    return response.data;
  },

  async changeLibVehRobo(
    vm,
    efirma,
    disposicionAutoridad,
    vehiculoCorralon,
    movNoLib,
    disposicion
  ) {
    var formData = new FormData();
    formData.append("nrreporte", vm.reporteInfo.nrreporte);
    formData.append("svindice", vm.reporteInfo.svindice);
    formData.append("aiclave", vm.reporteInfo.aiclave);
    formData.append("efirma", efirma);
    formData.append("disposicionAutoridad", disposicionAutoridad);
    formData.append("vehiculoCorralon", vehiculoCorralon);
    formData.append("movNoLib", movNoLib);
    formData.append("disposicion", disposicion);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}Movimientos/MovLibVehRobo`,
      formData
    );

    return response.data;
  },
    MovimientoRCM(vm, data) {
        data.append("aiclave", vm.aiclave);
        data.append("uslogin", MetodosGenerales.ObtenerUserName());
    return vm.axios
      .post(`${domain.domainNameForApi}Movimientos/MovimientoRCM`, data)
      .then((response) => response.data);
  },
  ComprobarHistorial(vm, data) {
    return vm.axios.post(`${domain.domainNameForApi}Movimientos/ComprobarHistorial`, data).then((response) => response.data);
  },
};
